import React from "react";
import { useLocaleContext } from "../../context/LocaleContext";
import { CButton } from "../../components/UI";

export default ({tokenBlocked, accessBlocked}) => {
    const { get } = useLocaleContext();

    return <section>
        <div className="authentication token-blocked">
            {tokenBlocked && <p>{get('auth.login.token-blocked')}</p>}
            {accessBlocked && <p>{get('auth.login.private-event')}</p>}
            {/* <CButton size="lg" theme="accent" label={get('auth.login.try-form')} onClick={onTryLoginForm} /> */}
        </div>
    </section>
} 